import { ColDef } from 'ag-grid-community';

const getTooltipProps = (column: ColDef, tooltipFieldByTypes: string[] = []) => {
  const tooltipTypeExist = tooltipFieldByTypes.includes(column.type as string);

  return tooltipTypeExist
    ? {
        tooltipField: column.field,
      }
    : {};
};

export const addTooltipPropsForColDefs = (tooltipFieldByTypes: string[]) => (columns: ColDef[]) =>
  columns.map((column) => ({
    ...column,
    ...getTooltipProps(column, tooltipFieldByTypes),
  }));
